import React from "react"
import SubscriptionFeatureAccess from "../../subscriptions/components/SubscriptionFeatureAccess"
import ExecutiveAlertsPanel from "./ExecutiveAlertsPanel"
import ExecutiveActionsPanel from "./ExecutiveActionsPanel"

export default function DashboardExecutiveFeedSection({
  executiveFeedsEnabled,
  executiveFeedsFeatureKey,
  currentPlanName,
  openUpgrade,
  loading,
  topFinancialAlerts,
  topExecutiveActions,
  collapsedSections,
  toggleSection,
  openFinancialAction,
  openActionTarget,
  getActionCardStyle
}) {
  const alerts = Array.isArray(topFinancialAlerts) ? topFinancialAlerts : []
  const actions = Array.isArray(topExecutiveActions) ? topExecutiveActions : []

  const showAlertsPanel = !executiveFeedsEnabled || loading || alerts.length > 0
  const showActionsPanel = !executiveFeedsEnabled || loading || actions.length > 0

  if (executiveFeedsEnabled && !loading && !showAlertsPanel && !showActionsPanel) {
    return null
  }

  return (
    <SubscriptionFeatureAccess
      enabled={executiveFeedsEnabled}
      featureKey={executiveFeedsFeatureKey}
      planName={currentPlanName}
      subtitle="Desbloquea alertas y acciones automáticas de nivel ejecutivo en vista multi-clínica."
      onUpgrade={() => openUpgrade(executiveFeedsFeatureKey)}
    >
      <div
        style={{
          display: "grid",
          gap: 16,
          marginBottom: 16,
          alignItems: "start"
        }}
      >
        {showAlertsPanel && (
          <ExecutiveAlertsPanel
            loading={loading}
            alerts={alerts}
            collapsed={!!collapsedSections.financialAlerts}
            onToggle={() => toggleSection("financialAlerts")}
            onOpenAlert={(alert) => {
              const targetMap = {
                LOW_COLLECTION_EFFICIENCY: "production-vs-collection",
                MEDIUM_COLLECTION_EFFICIENCY: "production-vs-collection",
                HIGH_PENDING_PORTFOLIO: "aging",
                MEDIUM_PENDING_PORTFOLIO: "aging",
                HIGH_CREDIT_BALANCE: "credit-balance",
                AGING_91_PLUS: "aging",
                AGING_91_PLUS_PRESENT: "aging",
                CRITICAL_TOP_DEBTOR: "top-debtors"
              }

              openFinancialAction(
                targetMap[alert.code] || "top-debtors",
                alert.clinicId
              )
            }}
          />
        )}

        {showActionsPanel && (
          <ExecutiveActionsPanel
            loading={loading}
            actions={actions}
            collapsed={!!collapsedSections.executiveActions}
            onToggle={() => toggleSection("executiveActions")}
            onOpenAction={openActionTarget}
            getActionCardStyle={getActionCardStyle}
          />
        )}
      </div>
    </SubscriptionFeatureAccess>
  )
}